define('webshopProductsCategoriesListSelectHeaderView',[
  'module',
  'underscore',
  'tableHeaderFieldView',
  'template!webshopProductsCategoriesListSelectHeaderView'
], function (
  Module,
  _,
  FieldView,
  Tpl
) {
  'use strict';

  /**
   * "Select all" checkbox of the current page.
   */
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-categories-list-select-header-view ' + FieldView.prototype.className,

    ui: _.extend({}, FieldView.prototype.ui, {
      checked: '.checked',
      unchecked: '.unchecked'
    }),

    events: {
      'click': 'onClick'
    },

    attributes: function () {
      return {
        title: _.i18n('webshop.products.categories.list.selectAll', null, 'Select / unselect the whole page')
      };
    },

    onRender: function () {
      this.listenTo(this.tableView.selectedProducts, 'change', this.renderState);
      this.renderState();
    },

    allSelected: function () {
      if (!this.tableView.bodyView)
        return false;

      var count = this.tableView.bodyView.collection.length;
      return count > 0 && this.tableView.getSelected().length === count;
    },

    renderState: function () {
      if (this.isDestroyed)
        return;

      if (this.allSelected()) {
        this.ui.checked.css('display', 'flex');
        this.ui.unchecked.hide();
      } else {
        this.ui.checked.hide();
        this.ui.unchecked.css('display', 'flex');
      }
    },

    onClick: function (e) {
      e.stopPropagation();

      if (!this.tableView.bodyView)
        return;

      if (this.allSelected())
        this.tableView.unSelectAll();
      else
        this.tableView.selectAll();

      if (this.tableView.onSelected)
        this.tableView.onSelected(this.tableView.getSelected());
    }
  });
});

